export default "__VITE_ASSET__DuaDzBYj__"